(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_footer-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nc-footer-menu')) {
    customElements.define(
      'nc-footer-menu',
      class extends HTMLElement {
        connectedCallback() {
          this.details = this.querySelector('details');
          this.summary = this.querySelector('summary');
          this.query = window.matchMedia('(min-width: 768px)');
          this.onChange = () => this.sync();
          this.onClick = (event) => {
            if (this.query.matches) event.preventDefault();
          };
          this.query.addEventListener('change', this.onChange);
          this.summary.addEventListener('click', this.onClick);
          this.sync();
        }

        disconnectedCallback() {
          this.query.removeEventListener('change', this.onChange);
          this.summary.removeEventListener('click', this.onClick);
        }

        sync() {
          this.details.open = this.query.matches;
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nc-product-form')) {
    customElements.define(
      'nc-product-form',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.button = this.querySelector('[data-add-to-cart-button]');
          this.label = this.querySelector('[data-add-to-cart-text]');
          this.errorEl = this.querySelector('[data-form-error]');
          this.defaultLabel = this.label ? this.label.textContent : '';
          this.onSubmit = this.onSubmit.bind(this);
          this.onVariantRendered = this.onVariantRendered.bind(this);
          this.form.addEventListener('submit', this.onSubmit);
          document.addEventListener('variant:rendered', this.onVariantRendered);
        }

        disconnectedCallback() {
          this.form.removeEventListener('submit', this.onSubmit);
          document.removeEventListener('variant:rendered', this.onVariantRendered);
        }

        // Take the add-to-cart state (sold out, price label) from the re-rendered section.
        onVariantRendered(event) {
          const doc = event.detail.doc;
          const next = doc.querySelector('[data-add-to-cart-button]');
          const nextLabel = doc.querySelector('[data-add-to-cart-text]');
          if (!next || !this.button) return;
          this.button.disabled = next.disabled;
          if (nextLabel && this.label) {
            this.defaultLabel = nextLabel.textContent;
            this.setLabel(this.defaultLabel);
          }
          const checkout = this.closest('.nc-product-buy-buttons')?.querySelector('.nc-product__checkout');
          if (checkout) checkout.hidden = next.disabled;
        }

        onSubmit(event) {
          event.preventDefault();
          this.addToCart();
        }

        setLabel(text) {
          if (this.label) this.label.textContent = text;
        }

        showError(message) {
          if (!this.errorEl) return;
          this.errorEl.textContent = message;
          this.errorEl.hidden = false;
        }

        hideError() {
          if (!this.errorEl) return;
          this.errorEl.hidden = true;
          this.errorEl.textContent = '';
        }

        async addToCart() {
          this.hideError();
          this.button.disabled = true;
          this.setLabel(this.dataset.addingLabel);

          const formData = new FormData(this.form);
          formData.append('sections', 'cart-drawer');
          formData.append('sections_url', window.location.pathname);

          try {
            const response = await fetch(this.dataset.addUrl, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: formData,
            });
            const data = await response.json();

            if (!response.ok) {
              this.showError(data.description || data.message || this.dataset.genericError);
              return;
            }

            const cart = await fetch(this.dataset.cartUrl).then((res) => res.json());
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, sections: data.sections } }));
            document.dispatchEvent(new CustomEvent('cart:open'));

            this.setLabel(this.dataset.addedLabel);
            setTimeout(() => this.setLabel(this.defaultLabel), 1500);
          } catch (error) {
            this.showError(this.dataset.genericError);
          } finally {
            this.button.disabled = false;
          }
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nc-share-copy')) {
    customElements.define(
      'nc-share-copy',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', () => this.copy());
        }

        copy() {
          navigator.clipboard.writeText(this.dataset.url);
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nc-variant-picker')) {
    customElements.define(
      'nc-variant-picker',
      class extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          const script = this.querySelector('[data-variants]');
          this.variants = script ? JSON.parse(script.textContent) : [];
          this.addEventListener('change', this.onChange.bind(this));
        }

        onChange() {
          const fields = Array.from(this.querySelectorAll('[data-option-position]'));
          const positions = [...new Set(fields.map((field) => field.dataset.optionPosition))].sort(
            (a, b) => Number(a) - Number(b),
          );
          const selected = positions.map((position) => {
            const field = fields.find(
              (candidate) =>
                candidate.dataset.optionPosition === position && (candidate.tagName === 'SELECT' || candidate.checked),
            );
            return field ? field.value : null;
          });

          positions.forEach((position, index) => {
            const label = this.querySelector(`[data-option-label="${position}"]`);
            if (label && selected[index] !== null) label.textContent = selected[index];
          });

          const variant = this.variants.find((candidate) =>
            candidate.options.every((value, index) => value === selected[index]),
          );
          if (!variant) return;

          const scope = this.closest('.nc-product-section') || document;
          scope.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
            input.value = variant.id;
          });

          this.updateUrl(variant.id);
          this.updateFromSection(variant);

          document.dispatchEvent(
            new CustomEvent('variant:changed', { detail: { variant, sectionId: this.sectionId } }),
          );
        }

        updateUrl(variantId) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url);
        }

        updateFromSection(variant) {
          const url = new URL(window.location.pathname, window.location.origin);
          url.searchParams.set('variant', variant.id);
          url.searchParams.set('section_id', this.sectionId);

          fetch(url)
            .then((response) => response.text())
            .then((html) => {
              // Ignore a slow response when the shopper has already picked another variant.
              if (new URL(window.location.href).searchParams.get('variant') !== String(variant.id)) return;
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const root = this.closest('.nc-product__info') || document;
              const priceEl = root.querySelector('.nc-price--lg');
              const next = doc.querySelector('.nc-price--lg');
              if (priceEl && next) priceEl.replaceWith(next);
              document.dispatchEvent(
                new CustomEvent('variant:rendered', { detail: { variant, doc, sectionId: this.sectionId } }),
              );
            });
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

})();
